// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.five9-chat-button {\n    background: #FFC72C!important;\n    display: none!important;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
